export default "__VITE_ASSET__DnjP7f4W__"